import { fetchProviderSelectionMetadataWithCount, FilterMetadataApiWithCountReturn } from "../misc";
import { useCallback, useRef } from "react";
import { useAsync } from "../hooks";
import { SearchParams } from "./useProviderFilterWithFetch";

export const useProvidersSelectionMetadataWithCount = ({
    searchParams,
    metadataWithCount,
    setMetadataWithCount
}: {
    searchParams?: SearchParams;
    metadataWithCount?: FilterMetadataApiWithCountReturn;
    setMetadataLoading?: React.Dispatch<React.SetStateAction<boolean>>;
    setMetadataWithCount?: React.Dispatch<React.SetStateAction<FilterMetadataApiWithCountReturn>>;
}) => {
    const ref = useRef<{
        searchParams?: SearchParams;
        metadataWithCount?: FilterMetadataApiWithCountReturn;
    }>({
        searchParams,
        metadataWithCount
    });

    const load = useCallback(
        async (signal?: AbortSignal): Promise<FilterMetadataApiWithCountReturn> => {
            if (!metadataWithCount) return;

            // if metadatawithcount is a related searchparams result (being tracked in ref)
            if (searchParams === ref.current.searchParams && metadataWithCount === ref.current.metadataWithCount) {
                return;
            }

            const _metadataWithCount = await fetchProviderSelectionMetadataWithCount(metadataWithCount, searchParams, {
                signal
            });

            return _metadataWithCount;
        },
        [searchParams, metadataWithCount]
    );

    const onLoad = useCallback(
        (metadataWithCount: FilterMetadataApiWithCountReturn) => {
            if (metadataWithCount === undefined) return;

            ref.current.searchParams = searchParams;
            ref.current.metadataWithCount = metadataWithCount;
            setMetadataWithCount && setMetadataWithCount(metadataWithCount);
        },
        [searchParams, setMetadataWithCount]
    );

    useAsync(load, onLoad);
};
